<!-- 健康年齢 -->
<template>
  <div class="section2--container">
    <div class="section2--content section2--content__heading">
      <slot name="heading"/>
    </div>

    <div :style="{color: textcolor}" class="section2--content section2__health-age">
        <div class="section2__health-age--inner-content">
          <slot name="text"/>
        </div>

        <div class="section2__health-age--inner-content">
          <slot name="value-with-unit"/>
        </div>

        <div class="section2__health-age--inner-content section2__health-age--inner-content__chart">
          <slot name="chart"/>
        </div>
    </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
        textcolor: VueTypes.string.isRequired
    }
}
</script>

<style scoped>
  .section2__health-age {
    margin-top: 40px;
  }
  .section2__health-age--inner-content {
    width: 100%;
    margin-top: 20px;
  }
</style>
